<template>
  <div class="shilinHome">
    <Header
      :tabList="tabList"
      @change="onTabChange"
      :value="selectValue"
      @lang="onLanChane"
      :isForeign="isForeign"
    ></Header>
    <router-view></router-view>
    <Footer></Footer>
  </div>
</template>
<script>
import { mapState } from "vuex";
import Header from "../shilin/components/header";
import Footer from "../shilin/components/footer";
export default {
  components: {
    Header,
    Footer,
  },
  provide() {
    return {
      reload: this.reload,
    };
  },
  data() {
    return {
      tabList: [
        {
          label: "首页",
          value: "home",
          routeName: "shilinHomePage",
          path: "/index",
        },
        {
          label: "印象石林",
          value: "introduce",
          routeName: "shilinintroduce",
          path: "/strategy",
        },
        {
          label: "度假攻略",
          value: "strage",
          routeName: "shilinstrategy",
          path: "/shilinstrategy",
        },
        {
          label: "活动盛世",
          value: "news",
          routeName: "shilinactive",
          path: "/newslist",
        },
        {
          label: "信息公告",
          value: "infor",
          routeName: "shilinnewslist",
          path: "/newslist",
        },
        {
          label: "在线预订",
          value: "shilinbook",
          routeName: "shilinbook",
          path: "/ticketlist",
          children: [
            {
              label: "门票预订",
              value: "ticket",
              routeName: "shilinTicketlist",
              path: "/ticketlist",
            },
            {
              label: "酒店预订",
              value: "hotel",
              routeName: "shilinhotellist",
              path: "/hotellist",
            },
            {
              label: "美食预订",
              value: "eatery",
              routeName: "shilineaterylist",
              path: "/eaterylist",
            },
            {
              label: "文创特产",
              value: "shop",
              routeName: "shilinshoplist",
              path: "/shoplist",
            },
          ],
        },
        {
          label: "虚拟游",
          value: "virtualTravel",
          routeName: "virtualTravel",
          path: "/virtualTravel",
        },
      ],
      selectValue: "shilinHomePage",
      ticketList: [],
      isForeign: false,
    };
  },
  computed: {
    ...mapState("privateConfig", ["pageWidth"]),
  },
  watch: {
    $route(val) {
      this.selectValue = localStorage.getItem("selectValue");
    },
  },
  methods: {
    reload() {
      this.isRouterAlive = false;
      //在修改数据之后使用 $nextTick，则可以在回调中获取更新后的 DOM
      this.$nextTick(() => {
        this.isRouterAlive = true;
      });
    },
    onLanChane(type) {
      if (type === "chinese") {
        this.isForeign = false;
      } else {
        this.isForeign = true;
      }
    },
    onTabChange(data) {
      this.selectValue = data.routeName;
      localStorage.setItem("selectValue", data.routeName);

      if (data.routeName === "shilinstrategy") {
        localStorage.setItem("news_title", "度假攻略");
        this.$router.push(
          "/shilinstrategy?m_id=" + this.$route.query.m_id + "&pid=911"
        );
      } else if (data.routeName === "shilinnewslist") {
        localStorage.setItem("news_title", "信息公告");
        this.$router.push(
          "/newslist?m_id=" + this.$route.query.m_id + "&pid=914"
        );
      } else if (data.routeName === "shilinintroduce") {
        this.$router.push(
          "/introduce?m_id=" + this.$route.query.m_id + "&pid=2500&menuId=910"
        );
      } else if (data.routeName === "shilinactive") {
        localStorage.setItem("news_title", "活动盛世");
        this.$router.push(
          "/newslist?m_id=" + this.$route.query.m_id + "&pid=912"
        );
      } else if (data.routeName === 'virtualTravel') { // 虚拟游
        window.open('https://720yun.com/t/63vkzl7wzib');
      } else {
        this.$router.push({
          name: data.routeName,
        });
      }
    },
  },
};
</script>
<style scoped>
.bameiHome {
  width: 100%;
  overflow: hidden;
  background: #f7f7f7;
}
</style>


// WEBPACK FOOTER //
// src/pages/shilin/index.vue